import { Component } from '@theme/component';

const COLORS = ['#FFFFFF', '#DEEBFF', '#FFD84D', '#E6F7D2'];
const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

/**
 * Intercepte le bouton « Paiement » du panier (tiroir et page), joue le disque + confettis,
 * puis soumet le formulaire avec ce même bouton (donc vers le checkout).
 */
class HdCheckoutFx extends Component {
  requiredRefs = ['dialog', 'disque', 'confettis'];

  #running = false;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('click', this.#onClick, true);
    // Si on revient sur la page (bfcache), le voile ne doit pas rester affiché.
    window.addEventListener('pageshow', this.#reset);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('click', this.#onClick, true);
    window.removeEventListener('pageshow', this.#reset);
  }

  #reset = () => {
    this.#running = false;
    const { dialog } = this.refs;
    dialog.dataset.state = '';
    if (dialog.open) dialog.close();
    this.refs.confettis.replaceChildren();
  };

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    if (REDUCED.matches || this.#running) return;
    const target = /** @type {HTMLElement | null} */ (event.target);
    const button = /** @type {HTMLButtonElement | null} */ (target?.closest('button[name="checkout"]'));
    if (!button || button.disabled) return;
    const form = button.form;
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    this.#running = true;

    const rect = button.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;
    const d = 2 * Math.hypot(Math.max(x, window.innerWidth - x), Math.max(y, window.innerHeight - y));
    const { dialog } = this.refs;
    dialog.style.setProperty('--hd-fx-x', `${x}px`);
    dialog.style.setProperty('--hd-fx-y', `${y}px`);
    dialog.style.setProperty('--hd-fx-d', `${Math.ceil(d)}px`);

    // showModal() place le voile dans la couche supérieure, au-dessus du tiroir panier (lui aussi un dialog).
    if (!dialog.open) dialog.showModal();
    dialog.addEventListener('cancel', (e) => e.preventDefault(), { once: true });
    requestAnimationFrame(() => {
      dialog.dataset.state = 'on';
      window.setTimeout(() => this.#confetti(), 320);
    });

    window.setTimeout(() => {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(button);
      else form.submit();
    }, 1150);

    // Filet : si rien ne s'est passé (erreur, blocage), on rend la main.
    window.setTimeout(() => {
      if (this.#running) this.#reset();
    }, 4500);
  };

  #confetti() {
    const host = this.refs.confettis;
    const frag = document.createDocumentFragment();
    const count = 34;
    for (let i = 0; i < count; i++) {
      const el = document.createElement('span');
      el.className = 'hd-fx__chevron';
      el.style.setProperty('--c', COLORS[i % COLORS.length]);
      frag.appendChild(el);

      const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.6;
      const dist = 140 + Math.random() * Math.min(window.innerWidth, window.innerHeight) * 0.42;
      const dx = Math.cos(angle) * dist;
      const dy = Math.sin(angle) * dist - 40;
      const rot0 = Math.random() * 360;
      const rot1 = rot0 + (Math.random() > 0.5 ? 1 : -1) * (180 + Math.random() * 360);
      const delay = Math.random() * 180;

      el.animate(
        [
          { transform: `translate(-50%, -50%) translate(0, 0) rotate(${rot0}deg) scale(0.4)`, opacity: 0 },
          { transform: `translate(-50%, -50%) translate(${dx * 0.6}px, ${dy * 0.6}px) rotate(${(rot0 + rot1) / 2}deg) scale(1.1)`, opacity: 1, offset: 0.35 },
          { transform: `translate(-50%, -50%) translate(${dx}px, ${dy + 90}px) rotate(${rot1}deg) scale(0.9)`, opacity: 0 },
        ],
        { duration: 1300 + Math.random() * 500, delay, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)', fill: 'forwards' }
      );
    }
    host.replaceChildren(frag);
  }
}

if (!customElements.get('hd-checkout-fx')) customElements.define('hd-checkout-fx', HdCheckoutFx);
